
export const start = (previousState, action) =>
    ({...previousState, activePollers:  [...previousState.activePollers, action.payload] })

export const stop = (previousState, action) => {
    const pollers = previousState.activePollers.filter(poller => poller !== action.payload)
    return {...previousState, activePollers: [...pollers]}
}
